import React, { useState } from 'react';
import { XIcon, CalendarIcon, ClockIcon } from 'lucide-react';
interface CreateCoffeeModalProps {
  isOpen: boolean;
  onClose: () => void;
}
const CreateCoffeeModal: React.FC<CreateCoffeeModalProps> = ({
  isOpen,
  onClose
}) => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [date, setDate] = useState('');
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [platform, setPlatform] = useState('Google Meet');
  const [meetingLink, setMeetingLink] = useState('');
  const [selectedTopics, setSelectedTopics] = useState<string[]>([]);
  const topics = ['Sostenibilità', 'Innovazione', 'Economia Circolare', 'ESG', 'Energie Rinnovabili', 'Green Finance', 'Carbon Management', 'Reporting di Sostenibilità', 'Moda Sostenibile', 'Net-Zero'];
  const handleTopicToggle = (topic: string) => {
    if (selectedTopics.includes(topic)) {
      setSelectedTopics(selectedTopics.filter(t => t !== topic));
    } else {
      setSelectedTopics([...selectedTopics, topic]);
    }
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // In a real app, you would save the event here
    console.log({
      title,
      description,
      date,
      startTime,
      endTime,
      platform,
      meetingLink,
      selectedTopics
    });
    onClose();
  };
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 overflow-y-auto" data-id="element-433">
      <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" data-id="element-434">
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" onClick={onClose} data-id="element-435"></div>
        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full" data-id="element-436">
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4" data-id="element-437">
            <div className="flex justify-between items-center mb-4" data-id="element-438">
              <h3 className="text-lg font-medium text-gray-900" data-id="element-439">
                Crea Nuovo Evento
              </h3>
              <button onClick={onClose} className="text-gray-400 hover:text-gray-500" data-id="element-440">
                <XIcon size={20} data-id="element-441" />
              </button>
            </div>
            <form onSubmit={handleSubmit} data-id="element-442">
              <div className="space-y-4" data-id="element-443">
                <div data-id="element-444">
                  <label htmlFor="title" className="block text-sm font-medium text-gray-700" data-id="element-445">
                    Titolo
                  </label>
                  <input type="text" id="title" value={title} onChange={e => setTitle(e.target.value)} required className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-custom-green focus:border-custom-green sm:text-sm" placeholder="Es: Innovazione nelle strategie ESG" data-id="element-446" />
                </div>
                <div data-id="element-447">
                  <label htmlFor="description" className="block text-sm font-medium text-gray-700" data-id="element-448">
                    Descrizione
                  </label>
                  <textarea id="description" value={description} onChange={e => setDescription(e.target.value)} required rows={3} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-custom-green focus:border-custom-green sm:text-sm" placeholder="Descrivi brevemente l'argomento dell'evento..." data-id="element-449"></textarea>
                </div>
                <div className="grid grid-cols-2 gap-4" data-id="element-450">
                  <div data-id="element-451">
                    <label htmlFor="date" className="block text-sm font-medium text-gray-700" data-id="element-452">
                      Data
                    </label>
                    <div className="mt-1 relative rounded-md shadow-sm" data-id="element-453">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-454">
                        <CalendarIcon size={16} className="text-gray-400" data-id="element-455" />
                      </div>
                      <input type="date" id="date" value={date} onChange={e => setDate(e.target.value)} required className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-custom-green focus:border-custom-green sm:text-sm" data-id="element-456" />
                    </div>
                  </div>
                  <div data-id="element-457">
                    <label htmlFor="platform" className="block text-sm font-medium text-gray-700" data-id="element-458">
                      Piattaforma
                    </label>
                    <select id="platform" value={platform} onChange={e => setPlatform(e.target.value)} required className="mt-1 block w-full pl-3 pr-10 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-custom-green focus:border-custom-green sm:text-sm" data-id="element-459">
                      <option value="Google Meet" data-id="element-460">Google Meet</option>
                      <option value="Microsoft Teams" data-id="element-461">Microsoft Teams</option>
                      <option value="Zoom" data-id="element-462">Zoom</option>
                      <option value="Altro" data-id="element-463">Altro</option>
                    </select>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-4" data-id="element-464">
                  <div data-id="element-465">
                    <label htmlFor="startTime" className="block text-sm font-medium text-gray-700" data-id="element-466">
                      Ora inizio
                    </label>
                    <div className="mt-1 relative rounded-md shadow-sm" data-id="element-467">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-468">
                        <ClockIcon size={16} className="text-gray-400" data-id="element-469" />
                      </div>
                      <input type="time" id="startTime" value={startTime} onChange={e => setStartTime(e.target.value)} required className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-custom-green focus:border-custom-green sm:text-sm" data-id="element-470" />
                    </div>
                  </div>
                  <div data-id="element-471">
                    <label htmlFor="endTime" className="block text-sm font-medium text-gray-700" data-id="element-472">
                      Ora fine
                    </label>
                    <div className="mt-1 relative rounded-md shadow-sm" data-id="element-473">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-474">
                        <ClockIcon size={16} className="text-gray-400" data-id="element-475" />
                      </div>
                      <input type="time" id="endTime" value={endTime} onChange={e => setEndTime(e.target.value)} required className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-custom-green focus:border-custom-green sm:text-sm" data-id="element-476" />
                    </div>
                  </div>
                </div>
                <div data-id="element-477">
                  <label htmlFor="meetingLink" className="block text-sm font-medium text-gray-700" data-id="element-478">
                    Link alla riunione (opzionale)
                  </label>
                  <input type="url" id="meetingLink" value={meetingLink} onChange={e => setMeetingLink(e.target.value)} className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-custom-green focus:border-custom-green sm:text-sm" placeholder="https://meet.google.com/..." data-id="element-479" />
                  <p className="mt-1 text-xs text-gray-500" data-id="element-480">
                    Puoi aggiungere il link ora o successivamente
                  </p>
                </div>
                <div data-id="element-481">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-482">
                    Temi dell'evento (seleziona fino a 3)
                  </label>
                  <div className="flex flex-wrap gap-2" data-id="element-483">
                    {topics.map(topic => <button key={topic} type="button" onClick={() => handleTopicToggle(topic)} disabled={selectedTopics.length >= 3 && !selectedTopics.includes(topic)} className={`px-3 py-1 rounded-full text-sm ${selectedTopics.includes(topic) ? 'bg-custom-green text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'} ${selectedTopics.length >= 3 && !selectedTopics.includes(topic) ? 'opacity-50 cursor-not-allowed' : ''}`} data-id="element-484">
                        {topic}
                      </button>)}
                  </div>
                  {selectedTopics.length === 0 && <p className="mt-1 text-xs text-red-500" data-id="element-485">
                      Seleziona almeno un tema
                    </p>}
                </div>
              </div>
              <div className="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense" data-id="element-486">
                <button type="submit" disabled={selectedTopics.length === 0} className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-custom-green text-base font-medium text-white hover:bg-custom-green/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-custom-green sm:col-start-2 sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-487">
                  Crea Evento
                </button>
                <button type="button" onClick={onClose} className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-custom-green sm:mt-0 sm:col-start-1 sm:text-sm" data-id="element-488">
                  Annulla
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>;
};
export default CreateCoffeeModal;